import _getIterator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/core-js/get-iterator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['ref2', 'isMultiple'],
  layout: 'blank',
  data: function data() {
    var isMulti = true;

    if (this.isMultiple === undefined || this.isMultiple === true) {
      isMulti = true;
    } else {
      isMulti = false;
    }

    return {
      dragAndDropCapable: false,
      dragging: false,
      items: [],
      multiple: isMulti,
      itemsDisplay: [],
      itemsAdded: '',
      allFiles: [],
      itemsNames: [],
      itemsSizes: [],
      itemsTotalSize: '',
      formData: '',
      successMsg: '',
      errorMsg: '',
      isUpload: false,
      isLoaderVisible: false
    };
  },
  mounted: function mounted() {
    var app = this;
    this.dragAndDropCapable = this.determineDragAndDropCapable();
    if (this.dragAndDropCapable) {
      var event = ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'];
      event.forEach(function (evt) {
        app.$refs.upload.addEventListener(evt, function (e) {
          e.preventDefault();
          e.stopPropagation();
        }, false);
      });

      this.$refs.upload.addEventListener('drop', function (e) {
        app.onChange(e, 'drop');
      });
    }
  },

  methods: {
    determineDragAndDropCapable: function determineDragAndDropCapable() {
      /*
          Create a test element to see if certain events
          are present that let us do drag and drop.
        */
      var div = document.createElement('div');

      /*
          Check to see if the `draggable` event is in the element
          or the `ondragstart` and `ondrop` events are in the element. If
          they are, then we have what we need for dragging and dropping files.
            We also check to see if the window has `FormData` and `FileReader` objects
          present so we can do our AJAX uploading
        */
      return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && 'FormData' in window && 'FileReader' in window;
    },
    uploadState: function uploadState() {
      this.isUpload = true;
    },
    getItems: function getItems() {
      return this.itemsDisplay;
    },
    reset: function reset() {
      this.removeItems();
    },
    bytesToSize: function bytesToSize(bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes === 0) return 'n/a';
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      if (i === 0) return bytes + ' ' + sizes[i];
      return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
    },
    removeItem: function removeItem(index) {
      //   var value = this.allFiles[index]
      this.itemsDisplay.splice(index, 1);
      this.calSize();
    },
    removeItems: function removeItems() {
      this.items = '';
      this.itemsAdded = '';
      this.itemsNames = [];
      this.itemsSizes = [];
      this.itemsDisplay = [];
      this.itemsTotalSize = '';
      this.dragging = false;
    },
    validSize: function validSize() {
      var fileSizes = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _getIterator(this.itemsDisplay), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var obj = _step.value;

          fileSizes += obj.size;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.errorMsg = '';
      if (fileSizes > 104857600) {
        this.errorMsg = 'Maxinum file size in queue is 100 MB';
        return false;
      }
      return true;
    },
    calSize: function calSize() {
      var fileSizes = 0;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = _getIterator(this.itemsDisplay), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var obj = _step2.value;

          fileSizes += obj.size;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.itemsTotalSize = this.bytesToSize(fileSizes);
    },
    onChange: function onChange(e, mode) {
      var inputFiles = null;

      if (mode === 'click') {
        inputFiles = e.target.files;
      } else {
        inputFiles = e.dataTransfer.files;
      }
      var lengthFile = inputFiles.length;

      for (var i = 0; i < lengthFile; i++) {
        var file = inputFiles[i];
        // console.log(file)
        this.itemsDisplay.push({
          name: file.name,
          sizeC: this.bytesToSize(file.size),
          size: file.size,
          file: file
        });
        if (!this.validSize()) {
          this.removeItem(this.itemsDisplay.length - 1);
        }
      }

      //   this.successMsg = ''
      //   this.errorMsg = ''

      //   let files = e.target.files || e.dataTransfer.files
      //   console.log(files)

      //   for (let x in files) {
      //     if (!isNaN(x)) {
      //       let file = e.target.files[x] || e.dataTransfer.files[x]
      //       this.itemsDisplay.push({
      //         name: file.name,
      //         sizeC: this.bytesToSize(files[x].size),
      //         size: file.size,
      //         file: file
      //       })
      //       if (!this.validSize()) {
      //         this.removeItem(this.itemsDisplay.length - 1)
      //       }
      //     }
      //   }
      //   this.calSize()
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/upload.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/upload.vue
// module chunks = 0 1 2 3 4 13 14 16 17 30 31 33 36